import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FolderTreeStateService } from '@components/ui-folder-tree/ui-folder-tree-state';
import { UiFolderTreeComponent } from '@components/ui-folder-tree/ui-folder-tree.component';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    FolderType,
    ModalResultType,
} from '@models';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: 'ui-folder-tree-modal.component.html',
    styleUrls: ['./ui-folder-tree-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiFolderTreeModalComponent extends UiModalComponent<FolderTreeStateService>
    implements OnDestroy {
    public FolderType = FolderType;

    @ViewChild(UiFolderTreeComponent, {static: true})
    public tree!: UiFolderTreeComponent;

    private _destroyed$ = new Subject();

    public get state() {
        return this.context.data;
    }

    public get highlighted() {
        return this.state.highlighted$.value;
    }

    ngOnDestroy() {
        this.state.searchValue = '';
        this._destroyed$.next();
        this._destroyed$.complete();
    }


    public switchFolder() {
        this.state
            .switchToHighlighted()
            .pipe(
                takeUntil(this._destroyed$),
            )
            .subscribe(success => {
                if (success) {
                    this._dialogRef.close({
                        type: ModalResultType.Succeeded,
                    });
                } else {
                    this.state.refresh();
                }
            });
    }
}
